import { motion } from 'framer-motion'

export function TypingIndicator() {
  return (
    <div className="flex w-full justify-start">
      <div className="flex items-end space-x-2 max-w-[75%]">
        {/* Bot Avatar */}
        <div className="flex-shrink-0 w-8 h-8 bg-carnival-400 rounded-full flex items-center justify-center shadow-outdoor-sm">
          <span className="text-white text-sm font-bold">🤖</span>
        </div>

        {/* Typing Bubble */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.3 }}
          className="px-4 py-3 rounded-2xl rounded-bl-lg bg-white/90 dark:bg-slate-800/90 border border-slate-200 dark:border-slate-600 shadow-outdoor-sm backdrop-blur-sm"
        >
          <div className="flex items-center space-x-1">
            {/* Typing Animation Dots */}
            {[0, 1, 2].map((index) => (
              <motion.div
                key={index}
                className="w-2 h-2 bg-slate-400 dark:bg-slate-500 rounded-full"
                animate={{ 
                  y: [0, -4, 0],
                  opacity: [0.7, 1, 0.7]
                }}
                transition={{
                  duration: 1.2,
                  repeat: Infinity,
                  delay: index * 0.2,
                  ease: 'easeInOut'
                }}
              />
            ))}
            
            <span className="ml-2 text-xs text-slate-500 dark:text-slate-400">
              Bot is typing...
            </span>
          </div>
        </motion.div>
      </div>
    </div>
  )
}